<template>
  <div class="popup_content">
    <v-popuptitle message="서식자료 변경 안내" imgsrc="sub/ic_popup.png"></v-popuptitle>
    <div class="popup__con_inner tac">
      <div class="popup__item">
        <div class="popup__box" style="text-align: left; padding: 20px">
          <p class="popup__text">
            4월 14일 이전에 종이서식을 다운로드하신 기관은
            <br />
            <b>최신 서식으로 변경</b>되었으므로,
            <br />
            <b>캐시 삭제 후 반드시 재다운로드</b>하여 사용해주시기 바랍니다.
          </p>
          <p class="popup__sub mt20">
            ※ 변경사항
            <br />
            • 종이서식 내 11번, 11-1번 항목이 추가되었습니다.
          </p>
          <p class="popup__sub mt20">
            ※ 캐시 삭제 방법 안내 (크롬 브라우저 기준)
            <br />
            1. 상단 오른쪽 모서리에 있는 메뉴 아이콘을 클릭합니다.
            <br />
            2. 추가 도구 > 검색 데이터 지우기를 선택합니다.
            <br />
            3. 시간 범위를 항상으로 설정합니다.
            <br />
            4. '쿠키 및 기타 사이트 데이터'와 '캐시된 이미지 또는 파일' 옆의 체크박스를 선택합니다.
            <br />
            5. 인터넷 사용 기록 삭제를 클릭합니다.
          </p>
          <div class="popup__sub mt20"> 또는, 설정 > 개인 정보 보호 및 보안 > 인터넷 사용 기록 삭제를 클릭해도 됩니다. </div>
        </div>
      </div>
      <div class="popup__close">
        <a href="javascript:;" style="background-color: #f0f0f0; color: #737373" @click="todayClose()">하루동안 보지 않기</a>
        <a href="javascript:;" @click="popupClose()">닫기</a>
      </div>
    </div>
  </div>
</template>

<script>
import popupTitle from '@/components/popup/PopupTitle.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    'v-popuptitle': popupTitle,
  },
  computed: {
    ...mapState('user', ['userOrganTargetType']),
    ...mapState('status', ['userOrganTargetTypeToPath']),
  },
  methods: {
    ...mapActions('popup', ['todayClose', 'popupClose']),
  },
};
</script>

<style scoped>
.popup__item {
  padding: 7px 80px 30px 80px;
}
.popup__box {
  padding: 30px 0;
  background: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  text-align: center;
}
.popup__text {
  line-height: 30px;
  font-size: 21px;
  font-weight: 700;
  color: #1c1c1c;
}
.popup__sub {
  line-height: 23px;
  font-size: 16px;
  color: #191919;
}
.popup__info {
  padding: 0 50px;
}
.popup__info table {
  border: 1px solid #cacaca;
}
.popup__info th,
.popup__info td {
  padding: 4px 13px;
  border-left: 1px solid #cacaca;
  line-height: 20px;
  font-size: 14px;
  color: #191919;
}
.popup__info th {
  font-weight: 700;
}
.popup__info td {
  text-align: left;
  font-weight: 400;
  letter-spacing: -0.5px;
}
.popup__info thead th {
  background-color: #f0f0f0;
}
.popup__info tbody th,
.popup__info tbody td {
  border-top: 1px solid #cacaca;
}
.popup__sm__text {
  font-size: 14px;
}
.popup__close {
  float: right;
  margin-right: 10px;
}
.popup__close a {
  padding: 10px 25px;
  margin-right: 10px;
  background-color: #0f6af0;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: white;
  vertical-align: middle;
}
</style>
